const administrationDocumentPath = new URL("app", new URL(import.meta.env.BASE_URL, "https://app.invalid/")).pathname;

/** Nur der exakte nginx-Pfad ist geschützt, niemals beliebige Pfade mit gleichem Suffix. */
export function isPublicWidgetDocument(location: Pick<Location, "pathname">): boolean {
  return location.pathname !== administrationDocumentPath;
}

const widgetRoutePaths = new Set([
  "/book/:bookingCode",
  "/lead/:bookingCode",
  "/contract-widget/:code",
  "/cancel-booking",
  "*",
]);

/** Ein Hash-Wechsel im freigegebenen Dokument darf niemals eine Verwaltungsroute öffnen. */
export function selectDocumentRoutes<T extends { path?: string }>(routes: T[], location: Pick<Location, "pathname">): T[] {
  return isPublicWidgetDocument(location) ? routes.filter(route => widgetRoutePaths.has(route.path ?? "")) : routes;
}

export function publicWidgetUrl(kind: "book" | "lead" | "contract-widget", code: string, query = ""): string {
  const url = new URL(import.meta.env.BASE_URL, window.location.href);
  url.hash = `/${kind}/${encodeURIComponent(code)}${query ? `?${query}` : ""}`;
  return url.href;
}

const CANCEL_BOOKING_ROUTE = "/cancel-booking";

/** Alte Verwaltungslinks bleiben beim normalen Öffnen gültig; niemals im Fremd-iframe umleiten. */
export function legacyAdministrationUrl(location: Pick<Location, "href" | "pathname" | "hash" | "search">, embedded: boolean): string | null {
  if (embedded || !isPublicWidgetDocument(location)) return null;
  const route = location.hash.startsWith("#/") ? location.hash.slice(1).split("?")[0] : location.pathname;
  if (/^\/(?:book|lead|contract-widget)\/[^/]+\/?$/.test(route) || route === CANCEL_BOOKING_ROUTE) return null;
  const url = new URL(administrationDocumentPath, location.href);
  url.search = location.search;
  url.hash = location.hash;
  return url.href;
}
